import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mt-3" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

import { PropType, toRef, ref } from "vue";

import Swal from "sweetalert2";

import { UploadInvest } from "@/services/invest/types";
import { InvestmentService } from "@/services/invest/investmentService";
import { EditInvest, Investment, Record } from "@/services/invest/types";

import NewModal from "../atoms/NewModal.vue";
import FormEditInvestment from "../molecules/FormEditInvestment.vue";
import FormRecord from "../molecules/FormRecord.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditInvestmentModal',
  props: {
  visible: {
    type: Boolean,
    default: false,
  },
  type: {
    type: Number,
    default: 0,
  },
  id: {
    type: Number,
    default: 0,
  },
  invest: {
    type: Object as PropType<Investment>,
    required: true,
  },
},
  emits: ["update:visible", "reload"],
  setup(__props, { emit }) {

const props = __props;





const idRef = toRef(props, "id");
const investmentService = new InvestmentService();
const isLoading = ref<boolean>(false);
const fileData = ref<any>(null);

async function editInvestiment(data: EditInvest) {
  let res = null;
  try {
    res = await investmentService.editInvestiment(data);
    if (res.success) {
      if (fileData.value != null) {
        editImageInvestiment(fileData.value);
        return;
      }
      emit("reload");
      emit("update:visible", false);
      Swal.fire(
        "¡Listo!",
        "La información se ha modificado de forma éxitosa",
        "success"
      );
    }
  } catch (error) {
    console.log(error);
    Swal.fire(
      "¡Error!",
      "Lo sentimos, hubo un error en el ingreso de la información",
      "error"
    );
  }
  return data;
}
async function saveData(data: any) {
  fileData.value = data;
}
async function editImageInvestiment(data: any) {
  let res = null;
  isLoading.value = true;
  if (props.invest.id) {
    let contractData = new UploadInvest(props.invest.id, data);
    res = await investmentService.uploadImage(contractData);
    if (!res.success) {
      Swal.fire(
        "¡Error!",
        "Lo sentimos, hubo un error en la subida de imagen",
        "error"
      );

      isLoading.value = false;

      return false;
    }
    Swal.fire(
      "¡Listo!",
      "La información se ha modificado de forma éxitosa, recargue la página para poder visualizar la imagen",
      "success"
    );
    isLoading.value = false;
  }
  window.location.reload();
  emit("reload");
  emit("update:visible", false);
  return res;
}
async function registerRecord(data: Record) {
  let res = null;
  try {
    res = await investmentService.createRecord(data);
    if (res.success) {
      emit("reload");
      emit("update:visible", false);
    }
  } catch (error) {
    console.log(error);
  }
  return res;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(NewModal, {
      title: "Edición de inversión",
      visible: __props.visible,
      "onUpdate:visible": _cache[0] || (_cache[0] = (e) => _ctx.$emit('update:visible', e))
    }, {
      footer: _withCtx(() => [
        _hoisted_4
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (__props.type == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(FormEditInvestment, {
                  invest: __props.invest,
                  id: idRef.value,
                  onAdd: editInvestiment,
                  onEditImage: saveData
                }, null, 8, ["invest", "id"])
              ]))
            : _createCommentVNode("", true),
          (__props.type == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(FormRecord, {
                  id: idRef.value,
                  onAdd: registerRecord
                }, null, 8, ["id"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})